module.exports = __webpack_public_path__ + "static/media/busca.27673c8c.svg";